/* */
export const ucfirst = (str) => {
  if (str.length > 0) {
    return str[0].toUpperCase() + str.substring(1);
  }
  return str;
};

/* */
export const parseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

/* */
export const parseStr = (string) => {
  const obj = {};
  string.split('&').forEach((d) => {
    const [name, value] = d.split('=');
    obj[name] = value;
  });
  return obj;
};

/* */
// Seconde barrière, en aval des liens Apollo : certains appels affichent le message
// d'une erreur brute (`err.message`) sans passer par `response.errors`. La règle
// historique réécrivait TOUT message contenant `Network error:` en « Connexion réseau
// interrompue », alors qu'Apollo préfixe ainsi n'importe quelle réponse HTTP non-2xx.
// On ne garde donc `errors.network` que pour un vrai échec de transport, celui où la
// requête n'a jamais atteint le serveur : `Network request failed` côté React Native,
// `Failed to fetch` côté navigateur.
const TRANSPORT_FAILURE = /Network request failed|Failed to fetch|NetworkError when/i;

export const handleError = (message) => String(message)
    .replace(/GraphQL error:/gi, '')
    .replace(/(Network error:.*)/gi, (match) => (TRANSPORT_FAILURE.test(match) ? 'errors.network' : 'errors.server_error'))
    .replace(/Error:/gi, '')
    .trim();

export const humanFileSize = (size) => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / 1024 ** i).toFixed(2) * 1} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

export const fileInfo = (filename) => {
  const a = `${filename}`.split('.');
  if (a.length === 1 || (a[0] === '' && a.length === 2)) {
    return {
      name: a,
      ext: '',
    };
  }
  const ext = a.pop();
  return {
    ext,
    name: a.join('.'),
  };
};
